import api from '../../services/api';

export type VideoSku = 'standard' | 'interactive';

export interface VideoEstimate {
  lowMilli: number;
  highMilli: number;
}

/** GET /billing/estimate: what a finished video of this SKU and tier is likely to use. */
export async function getVideoEstimate(params: { sku?: VideoSku; tier?: string } = {}): Promise<VideoEstimate | null> {
  const r = await api.get('/billing/estimate', { params });
  return r.data?.estimate ?? null;
}
